import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors} from '@angular/common/http';
import {isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouteReuseStrategy} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {DomainModule, LanguageInterceptor, LanguageService, TranslocoRootModule} from '@followme/domain';
import {SUCCESS_MESSAGES} from '@followme/shared/ui-core';
import {ReInitRouteReuseStrategy} from '@followme/shared/util-core';
import {
  dynamicEnvironment,
  ENVIRONMENT,
  ErrorEventsService,
  HeadersInterceptor,
  HeadersService,
  HttpErrorInterceptor,
  TOAST_SUCCESS_MESSAGES,
} from '@forlabs/api-bridge';
import {IonicModule} from '@ionic/angular';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import * as moment from 'moment';
import {TranslocoService} from '@jsverse/transloco';
import {getSentryAngularProviders} from '../../../../libs/sentry-integration/sentry-integration';
import {staticEnvironment} from '../environments/static-environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/fr';
import {provideEnvironmentNgxMask} from 'ngx-mask';

// EntityBuilder.enableCamelConversion = false;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    DomainModule,
    BrowserAnimationsModule,
    !staticEnvironment.production ? StoreDevtoolsModule.instrument() : [],
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    TranslocoRootModule,
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: ReInitRouteReuseStrategy},
    {provide: ErrorEventsService, useClass: ErrorEventsService},
    {provide: HeadersService, useClass: HeadersService},
    {provide: ENVIRONMENT, useValue: dynamicEnvironment},
    {provide: TOAST_SUCCESS_MESSAGES, useValue: SUCCESS_MESSAGES},
    {provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    ...getSentryAngularProviders(),
    LanguageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    provideEnvironmentNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private translocoService: TranslocoService,
  ) {
    moment.locale(this.translocoService.getActiveLang());
  }
}
